export const LANGUAGES: string[] = [
  'de', 'en', 'fr', 'it', 'pl', 'ro', 'hu', 'uk', 'cn', 'es',
  'mk', 'sr', 'ar', 'art', 'sk', 'pt', 'ptbr', 'cs', 'bg', 'lt', 'hr', 'sq',
];
